import { Box, DropdownButton, DropdownMenu, Flex, QuietButton, TruncatedText } from "@nulogy/components";
import React from "react";
import styled from "styled-components";
import DateTime from "utils/DateTime";
import Time from "utils/Time";
import { columnWidth } from "./WidthCalculator";

const CenteredHeader = styled(Flex)(
  ({ shiftCount }) => `
  align-items: center;
  justify-content: center;
  min-width: ${columnWidth(shiftCount)}px;
  max-width: ${columnWidth(shiftCount)}px;
`,
);

const ShiftName = styled(TruncatedText)(({ shiftCount, theme }) => ({
  color: theme.colors.darkGrey,
  fontWeight: "normal",
  maxWidth: `${columnWidth(shiftCount)}px`,
  paddingBottom: theme.sizes.half,
  paddingLeft: theme.sizes.half,
  paddingRight: theme.sizes.half,
  paddingTop: theme.sizes.half,
  textAlign: "center",
}));

const ShiftHeaderButton = styled(QuietButton)(({ shiftCount, theme }) => ({
  color: theme.colors.black,
  display: "block",
  margin: 0,
  maxWidth: `${columnWidth(shiftCount)}px`,
  minWidth: `${columnWidth(shiftCount)}px`,
  padding: 0,
}));

const ShiftTime = ({ children }) => (
  <Box
    color="midGrey"
    fontSize="12px"
    fontWeight="300"
    lineHeight="12px"
    paddingBottom="x1"
    paddingLeft="half"
    paddingRight="half"
    textAlign="center"
  >
    {children}
  </Box>
);

function ShiftInfo({ shift, shiftCount }) {
  return (
    <>
      <Flex fontWeight="normal" textAlign="center">
        <ShiftName fullWidth shiftCount={shiftCount}>
          {shift.name}
        </ShiftName>
      </Flex>
      <Flex justifyContent="center">
        <ShiftTime>
          {Time.to12HourShort(shift.startTime)} -
          <br />
          {Time.to12HourShort(shift.endTime)}&nbsp;&nbsp;
        </ShiftTime>
      </Flex>
    </>
  );
}

function shiftEnabled(shift, date) {
  const dayOfWeek = DateTime.dayOfWeekName(date).toLowerCase();

  return shift[dayOfWeek];
}

export default function AvailabilityShiftHeader({ shift, date, selectAllForShift, deselectAllForShift, shiftCount }) {
  if (!shiftEnabled(shift, date))
    return (
      <CenteredHeader shiftCount={shiftCount}>
        <Box
          marginBottom="1px"
          marginTop="1px"
          maxWidth={`${columnWidth(shiftCount)}px`}
          minWidth={`${columnWidth(shiftCount)}px`}
        >
          <ShiftInfo shift={shift} shiftCount={shiftCount} />
        </Box>
      </CenteredHeader>
    );

  return (
    <CenteredHeader shiftCount={shiftCount}>
      <DropdownMenu
        placement="bottom-start"
        trigger={() => (
          <ShiftHeaderButton shiftCount={shiftCount}>
            <ShiftInfo shift={shift} shiftCount={shiftCount} />
          </ShiftHeaderButton>
        )}
      >
        {({ closeMenu }) => (
          <>
            <DropdownButton
              onClick={(e) => {
                selectAllForShift(shift, date);
                closeMenu(e);
              }}
              type="button"
            >
              Select&nbsp;all
            </DropdownButton>
            <DropdownButton
              onClick={(e) => {
                deselectAllForShift(shift, date);
                closeMenu(e);
              }}
              type="button"
            >
              Deselect&nbsp;all
            </DropdownButton>
          </>
        )}
      </DropdownMenu>
    </CenteredHeader>
  );
}
